module.exports = __webpack_public_path__ + "img/doctor.71754c16.svg";